import React from "react";
import {App, SnackbarProvider} from "zmp-ui";
import {RecoilRoot} from "recoil";
import {BrowserRouter, Routes, Route} from 'react-router-dom'
import {Home} from "../pages";
import {Cart} from "../pages/cart";
import {OrderDetail} from "../pages/orderDetail";
import {Loading} from "./Loading";

const MyApp = () => {
   return (
      <RecoilRoot>
         <App>
            <SnackbarProvider>
               <BrowserRouter>
                  <Routes>
                     <Route path='/' element={<Home/>}/>
                     <Route path='/shopping/cart' element={<Cart/>}/>
                     <Route path='/shopping/detail' element={<OrderDetail/>}/>
                  </Routes>
               </BrowserRouter>
            </SnackbarProvider>
            <Loading/>
         </App>
      </RecoilRoot>
   );
};
export default MyApp;
